

import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useNavigate, useLocation } from 'react-router-dom';
import { AppProvider, useApp } from './context/AppContext';
import { SimuladoProvider } from './context/SimuladoContext';




import Statistics from './pages/Statistics/Statistics';
import ExamDetails from './pages/exam_details/exam_details';
import './App.css';
import ExamHistory from './pages/exams_history/exams_history';
import Login from './pages/Login/Login';
import Cadastro from './pages/Cadastro/Cadastro';
import EsqueciSenha from './pages/esqueci_senha/esqueci_senha';
import Perfil from './pages/Perfil/Perfil';
import Ranking from './pages/Ranking/Ranking';
import RedefinirSenha from './pages/redefinir_senha/redefinir_senha';
import Disciplinas from './pages/disciplinas/disciplinas';
import Relatorio from './pages/relatorio/relatorio';
import LocalDeProva from './pages/LocalDeProva/LocalDeProva';
import ExamSubscription from './pages/ExamSubscription/ExamSubscription';
import Notifications from './pages/Notifications/Notifications';
import ErrorPage from './pages/Error/Error';
import NotificationBell from './components/NotificationBell/NotificationBell';
import LetterboxWrapper from "./components/base/LetterboxWrapper/LetterboxWrapper";






const ConditionalNotificationBell = () => {
    const location = useLocation();
    const hidden = ['/login', '/error', '/cadastro', '/esqueciasenha', '/redefinir_senha'];
    if (hidden.some(path => location.pathname.startsWith(path))) return null;
    return <NotificationBell />;
};

const ProtectedRoutes = ({ children }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { user } = useApp();

    useEffect(() => {
        if (!user) {
            localStorage.setItem('redirectAfterLogin', location.pathname);
            navigate('/login');
        }
    }, [navigate, location]);

    return children;
};

function App() {
    return (
        
        // wrappers que permitem acessar o context
        <AppProvider>
        <SimuladoProvider>


        <Router>

            {/* wrapper pra ajustar visualização mobile */}
            <LetterboxWrapper>
            <ConditionalNotificationBell />
            <Routes>

                <Route path="/login" element={<Login />} />
                <Route path="/error" element={<ErrorPage />} />
                <Route path="/cadastro" element={<Cadastro />} />
                <Route path="/esqueciasenha" element={<EsqueciSenha />} />
                <Route path="/redefinir_senha.php" element={<RedefinirSenha />} />

                {/* redefinir_senha/* pra também abrir páginas  */}
                <Route path="/redefinir_senha/*" element={<RedefinirSenha />} />

                <Route path="/disciplinas" element={<Disciplinas />} />


                <Route
                    path="/relatorio"
                    element={
                        <ProtectedRoutes>
                            <Relatorio />
                        </ProtectedRoutes>
                    }
                />


                <Route
                    path="/dashboard"
                    element={
                        <ProtectedRoutes>
                            <Statistics />
                        </ProtectedRoutes>
                    }
                />

                <Route
                    path="/detalhes"
                    element={
                        <ProtectedRoutes>
                            <ExamDetails />
                        </ProtectedRoutes>
                    }
                />

                <Route
                    path="/historico"
                    element={
                        <ProtectedRoutes>
                            <ExamHistory />
                        </ProtectedRoutes>
                    }
                />

                <Route
                    path="/ranking"
                    element={
                        <ProtectedRoutes>
                            <Ranking />
                        </ProtectedRoutes>
                    }
                />

                <Route
                    path="/local-de-prova"
                    element={
                        <ProtectedRoutes>
                            <LocalDeProva />
                        </ProtectedRoutes>
                    }
                />

                <Route
                    path="/exam-subscription"
                    element={
                        <ProtectedRoutes>
                            <ExamSubscription />
                        </ProtectedRoutes>
                    }
                />

                <Route
                    path="/notifications"
                    element={
                        <ProtectedRoutes>
                            <Notifications />
                        </ProtectedRoutes>
                    }
                />

                <Route
                    path="/"
                    element={
                        <ProtectedRoutes>
                            <Perfil />
                        </ProtectedRoutes>
                    }
                />
            </Routes>
            </LetterboxWrapper>


        </Router>
        </SimuladoProvider>
        </AppProvider>
    );
}

export default App;
